import React, { useEffect, useCallback } from 'react';
import {
    EVENT_INITIATORS,
    INTERACTION_TYPES,
} from '@zocdoc-frontend-common/utils-frontend-metrics';
import { useLoadCreateAccountView } from 'src/Booking/utils/hooks/useLoadCreateAccountView';
import { useRequirePatientInfoComplete } from 'src/Booking/utils/hooks/useRequirePatientInfoComplete';
import useWarningOnUnload from '../../utils/hooks/useWarningOnUnload';
import CreateUsernamePageView from './CreateUsernamePageView';

/**
 *
 * @param {function} goBackToPatientInfo
 * @param {function} onSignInSuccess
 * @param {boolean} shouldShowLoginModal
 * @param {boolean} signedIn
 * @param {function} sendMetric
 * @param {function} openLoginModal
 * @param {Object} viewOnlyProps
 * @returns {JSX.Element}
 * @constructor
 */
const CreateUsernamePageContainer = ({
    goBackToPatientInfo,
    onSignInSuccess,
    shouldShowLoginModal,
    signedIn,
    sendMetric,
    openLoginModal,
    ...viewOnlyProps
}) => {
    // Trigger the popup saying input will be lost when the user refreshes the page
    useWarningOnUnload();

    // Fire page load metrics and scroll to top of page
    useLoadCreateAccountView({
        loadActionName: 'Loaded create username view',
        loadMetricName: 'booking-web-app.saw_create_username',
        sendMetric,
    });

    const onClickLoginLink = useCallback(() => {
        sendMetric({
            action: 'Click email already in use error login link',
            component: 'Email already in use error',
            element: 'Login link',
            initiator: EVENT_INITIATORS.USER,
            interactionType: INTERACTION_TYPES.CLICK,
        });
        openLoginModal();
    }, [openLoginModal, sendMetric]);

    useRequirePatientInfoComplete();

    useEffect(() => {
        if (signedIn) {
            onSignInSuccess();
        }
    }, [onSignInSuccess, signedIn]);

    const viewProps = {
        onSignInSuccess,
        shouldShowLoginModal,
        goBackToPatientInfo,
        sendMetric,
        onClickLoginLink,
        ...viewOnlyProps,
    };

    return <CreateUsernamePageView {...viewProps} />;
};

export default CreateUsernamePageContainer;
